<div class="container-fluid gx-5" style="height: calc(100vh - 273px); min-height: 400px;">
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;"><fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'gear']"></fa-icon> Reset
          Password
        </h3>
      </div>

      <!-- <p>Stage: {{stage}}</p> -->

      <div class="bg-light p-5 rounded-lg rounded-2">

        @if(stage === "NONE"){

        <form [formGroup]="noneForm" (ngSubmit)="submitNoneForm()" class="k-form-horizontal">

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="noneEmail" class="form-label col-3 k-label">Email</label>
            <div class="col-8">
              <input appAutoFocus type="text" class="form-control" id="noneEmail" formControlName="email"
                class="form-control">
              <div *ngIf="noneEmail?.invalid && (noneEmail?.dirty || noneEmail?.touched)" class="alert alert-danger">

                <div *ngIf="noneEmail?.errors?.['required']">
                  Email is required.
                </div>
                <div *ngIf="noneEmail?.errors && noneEmail?.errors?.['email']">Please, enter a valid email address.</div>

              </div>
            </div>
          </div>
          <!--
          <div class="mt-4 text-right" style="float: inline-end;">
            <button class="btn btn-primary m-1" type="submit" [disabled]="form.invalid"> Request SMS Code</button>
          </div> -->

          <div class="k-form-field" style="margin-bottom:8px;">
            <div class="col-8 offset-md-3">
              <!-- <div class="mt-4 text-right" style="float: inline-end;"> -->
              @if(busy) {
              <button class="btn btn-primary m-1" disabled="true"><fa-icon [icon]="['fat', 'spinner']"
                  [spin]="true"></fa-icon> Sending request for SMS Code</button>
              } @else {
              <button class="btn btn-primary m-1" type="submit" [disabled]="noneForm.invalid"> Request SMS Code</button>
              }
            </div>
          </div>

        </form>
        }

        @else if(stage === "SMS_RECEIVED"){

        <form [formGroup]="smsForm" (ngSubmit)="submitSmsForm()" class="k-form-horizontal">

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="smsEmail" class="form-label col-3 k-label">Email</label>
            <div class="col-8">
              <input appAutoFocus type="text" class="form-control" id="smsEmail" formControlName="email"
                class="form-control" readonly>
            </div>
          </div>
          <hr>
          <p>You should receive an auth code via SMS on your phone, please enter below to
            continue.<br>
            @if(!checking) {
            @if(b1){
            <span id="b1">The code will expire in <strong><span id="count_timer">{{timeleft}}</span></strong>.</span>
            }
            @if(b2) {
          <p id="b2"> You need to <button type="button" class="btn btn-link btn-casi-link" (click)="resendCode()">Resend
              a New Code</button> because the
            previous has expired.</p>
          }
          } @else {
          <span><fa-icon [icon]="['fat', 'spinner']" [spin]="true"></fa-icon></span>
          }
          </p>

          <div class="k-form-field" style="margin-bottom:8px;">
            <label for="smsauth" class="form-label col-3 k-label">Auth Code</label>
            <div class="col-8">
              <input appAutoFocus type="text" class="form-control" id="smsauth" formControlName="smsauth"
                class="form-control">
              <div *ngIf="smsAuth?.invalid && (smsAuth?.dirty || smsAuth?.touched)" class="alert alert-danger">

                <div *ngIf="smsAuth?.errors?.['required']">
                  Auth Code is required.
                </div>
                <div *ngIf="smsAuth?.errors?.['minlength'] || smsAuth?.errors?.['maxlength']">
                  Must be 6 digits.
                </div>
              </div>
              <!-- <p>Code Error: {{codeError}}</p> -->
              <div *ngIf="codeError===true" class="alert alert-danger">
                Incorrect Code.
              </div>
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <div class="col-8 offset-md-3">
              <!-- <div class="mt-4 text-right" style="float: inline-end;"> -->
              @if(checking) {
              <button class="btn btn-primary m-1" disabled="true"> <fa-icon [icon]="['fat', 'spinner']"
                  [spin]="true"></fa-icon> validating code</button>
              } @else {
              <button class="btn btn-primary m-1" type="submit" [disabled]="smsForm.invalid"> Confirm Code</button>
              }
            </div>
          </div>

        </form>
        }
        @else {

        <form [formGroup]="resetForm" (ngSubmit)="submitPWChange()" class="k-form-horizontal">

          <div class="form-group" style="margin-bottom:8px;">
            <div style="margin-top: -20px; margin-bottom: 20px;">
              <h4><b>Enter your new password</b></h4>
            </div>
          </div>

          <div class="k-form-field">
            <label for="password" class="form-label col-3 k-label">New Password</label>
            <div class="col-8">
              <input type="password" id="password" formControlName="password" class="form-control">
              <div *ngIf="f['password'].touched && f['password'].invalid" class="alert alert-danger">
                <div *ngIf="f['password'].errors && f['password'].errors['required']">Password is required.</div>
                <div *ngIf="password?.errors?.['minlength']">
                  Password must be at least 6 characters long.
                </div>
              </div>
            </div>
          </div>

          <div class="k-form-field">
            <label for="password" class="form-label col-3 k-label">Confirm Password</label>
            <div class="col-8">
              <input type="password" id="confirmedPassword" formControlName="confirmedPassword" class="form-control">
              <div *ngIf="f['confirmedPassword'].touched && f['confirmedPassword'].invalid" class="alert alert-danger">
                <div *ngIf="f['confirmedPassword'].errors && f['confirmedPassword'].errors['required']">Password is
                  required.</div>
                <div *ngIf="confirmedPassword?.errors?.['minlength']">
                  Confirm Password must be at least 6 characters long.
                </div>
              </div>
              <div *ngIf="resetForm.errors?.['confirmedPasswordValidator'] && (resetForm.touched || resetForm.dirty)"
                class="alert alert-danger">
                Passwords must match.</div>
            </div>
          </div>

          <div class="k-form-field" style="margin-bottom:8px;">
            <div class="col-8 offset-md-3">
              <!-- <div class="mt-4 text-right" style="float: inline-end;"> -->
              @if(busy) {
              <button class="btn btn-primary m-1" disabled="true"> <fa-icon [icon]="['fat', 'spinner']"
                  [spin]="true"></fa-icon> Updating Password</button>
              } @else {
              <button class="btn btn-primary m-1" type="submit" [disabled]="resetForm.invalid"> Save Password</button>
              }
            </div>
          </div>

        </form>
        }

      </div>
    </div>
  </div>

</div>

<div kendoDialogContainer></div>
